import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import styled from "@emotion/styled"

const HomePageOpportunity = ({ image, title, message }) => {
  return (
    <Link
      to="/app/signup?type=creator"
      state={{
        signupPayload: {
          message: message,
        },
      }}
    >
      <ContentSpacer>
        <ContentWithBackground
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0, 0.2), rgba(0,0,0, 0.5)), url(${
              !!image.childImageSharp ? image.childImageSharp.fluid.src : image
            })`,
          }}
        >
          <HomePageOpportunityContent>
            <HomePageOpportunityText>
              <HomePageOpportunityTitle className="has-text-weight-bold is-size-3-mobile is-size-2-tablet is-size-1-widescreen">
                {title}
              </HomePageOpportunityTitle>
            </HomePageOpportunityText>
          </HomePageOpportunityContent>
        </ContentWithBackground>
      </ContentSpacer>
    </Link>
  )
}

HomePageOpportunity.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string,
  message: PropTypes.string,
}

const ContentSpacer = styled.div`
  height: 300px;

  @media (min-width: 769px) {
    height: 600px;
  }
`

const ContentWithBackground = styled.div`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0;
`

const HomePageOpportunityContent = styled.div`
  text-align: center;
`

const HomePageOpportunityText = styled.div`
  line-height: 1;
  justify-content: space-around;
  flex-direction: column;
  display: flex;
`

const HomePageOpportunityTitle = styled.h3`
  color: white;
  padding: 0.25em;
  text-shadow: 2px 2px #603f8b;
`

export default HomePageOpportunity
